import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import StatisticsBody from './StatisticsBody';
import { admin, NOC } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import StatisticsProvider from './context/StatisticsProvider';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { VICE_PRESIDENT_FSE } from '../../../../../../utils/departments/helpers';

const Statistics = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <StatisticsProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="CNMAESTRO - Statistics" position={firstName} />
          <StatisticsBody />
        </main>
        <ToastContainer />
      </StatisticsProvider>
    </div>
  );
};

export default Statistics;
